import React from "react";
import CsvDownloadButton from "react-json-to-csv";
import { ImportResults } from "@shared/interfaces";

import { Button } from "../Common";

import "./index.scss";

interface ImportResultsModalProps {
  results: ImportResults;
  onClose: () => void;
}

const ImportResultsModal = (props: ImportResultsModalProps) => {
  const { onClose, results } = props;

  return (
    <div className="import-results-modal modal-content-wrapper">
      <div className="modal-heading">Import results</div>
      <div className="modal-content">
        <div>
          {results.successfully === 1
            ? `${results.successfully} patient was successfully uploaded`
            : `${results.successfully} patients were successfully uploaded`}
        </div>
        <div>
          {results.failed === 1
            ? `${results.failed} patient was not uploaded`
            : `${results.failed} patients were not uploaded`}
        </div>
        {results.failed_info.length ? (
          <div className="import-results">
            <CsvDownloadButton data={results.failed_info} filename="failed.csv">
              Download the file
            </CsvDownloadButton>
          </div>
        ) : null}
      </div>
      <div className="modal-actions">
        <Button appearance="subtle" className="subtle auto-width" onClick={onClose}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default ImportResultsModal;
